import { IconProps } from "@/data/types"

export default function WifiIcon({ width=32, height=32, color='#000000', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" strokeWidth="1.92" stroke={color} fill="none">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path d="M23.35,39.07a17.79,17.79,0,0,1,20.25-.35" strokeLinecap="round"></path>
          <path d="M16.31,31.28a28.27,28.27,0,0,1,34.61-.19" strokeLinecap="round"></path>
          <path d="M9.1,23.64a38.73,38.73,0,0,1,48.84-.34" strokeLinecap="round"></path>
          <line x1="33.48" y1="47.24" x2="33.48" y2="47.24" strokeLinecap="round"></line>
        </g>
      </svg>
    </div>
  )
}